import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';
import ScrollableContainer from 'components/ScrollableContainer';

export default class DetailPane extends Component {
  static contextTypes = {
    muiTheme: PropTypes.object
  };

  static propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  render() {
    let classes = ClassNames('detail-pane', this.props.className),
      titleElement =
        this.props.header && typeof this.props.header === 'string' ? (
          <h1>{this.props.header}</h1>
        ) : (
          this.props.header
        );
    return (
      <ScrollableContainer
        containerStyle={{
          backgroundColor: this.context.muiTheme.rawTheme.palette.canvasColor
        }}
        header={titleElement}
      >
        {this.props.children}
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/DetailPane.js